import { FunctionComponent } from 'react';
import LocationReject from '../components/LocationReject';

const LocalizationScreen: FunctionComponent = (): JSX.Element => {
  return <LocationReject></LocationReject>;
};

export default LocalizationScreen;
